import { Box, IconButton, TextField } from '@mui/material'
import React, { Fragment, useState } from 'react'
import { faRectangle } from '@fortawesome/pro-regular-svg-icons'
import { faTrash } from '@fortawesome/pro-thin-svg-icons'

import { sectionListItemStyles } from '../../styles/classes/FormBuilderClasses'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ConfirmationModal from '../general/ConfirmationModal'

import { useTranslation } from 'react-i18next'

const SectionListItem = ({
  sectionTitle,
  onSectionTitleChange,
  pageIndex,
  sectionIndex,
  onRemoveSection,
  trashable,
  allDisabled
}) => {
  const [title, setTtitle] = useState(sectionTitle)
  const { classes } = sectionListItemStyles()
  const [show, setShow] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const { t } = useTranslation()

  const editTitleHandler = event => {
    setTtitle(event.target.value)
    onSectionTitleChange(event.target.value, pageIndex, sectionIndex)
  }

  const removeSectionHandler = () => {
    onRemoveSection(pageIndex, sectionIndex)
  }

  const showModalHandler = () => {
    setShowConfirmationModal(prevVal => !prevVal)
  }

  return (
    <Fragment>
      <Box
        className={`${classes.container}`}
        onMouseOver={() => setShow(true)}
        onMouseOut={() => setShow(false)}
      >
        <Box className={classes.containerStyle}>
          <FontAwesomeIcon
            icon={faRectangle}
            className={classes.rectangleIcon}
          />
          <TextField
            fullWidth
            inputProps={{
              className: classes.inputStyle
            }}
            className={classes.text}
            variant="standard"
            InputProps={{ disableUnderline: true }}
            placeholder={t('form_builder.section_title')}
            onChange={editTitleHandler}
            value={title}
            id="section name"
            disabled={allDisabled}
          />
        </Box>
        {show && trashable && !allDisabled && (
          <Box display="flex">
            <IconButton
              size="small"
              className={classes.iconButton}
              onClick={showModalHandler}
            >
              <FontAwesomeIcon icon={faTrash} className={classes.trashIcon} />
            </IconButton>
          </Box>
        )}
      </Box>
      <ConfirmationModal
        title={t('form_builder.left_panel.remove_section_title')}
        message={t('form_builder.left_panel.remove_section_message', {
          sectionTitle: title
        })}
        open={showConfirmationModal}
        onMainAction={removeSectionHandler}
        onSecondaryAction={showModalHandler}
        mainActionLabel={t('form_builder.left_panel.accept')}
        secondaryActionLabel={t('form_builder.left_panel.cancel')}
      />
    </Fragment>
  )
}

export default SectionListItem
